// extracted by mini-css-extract-plugin
export default {"Spinner":"spinner_Spinner__GhqCN","brand":"spinner_brand__3O8ut"};